import Content from '../content-interface'
import Validity from '../validity.entity';
import DiscountRuleHistory from './discount-rules-history.entity';

export default class DiscountUpdatedHistory implements Content {
  strategy: string;

  type: string;

  justification: string;

  observation: string;

  validity: Validity

  rules: DiscountRuleHistory[]

  constructor(obj: any = {}) {
    this.strategy = obj.strategy || '';
    this.type = obj.type || '';
    this.justification = obj.justification || '';
    this.observation = obj.observation || '';
    this.validity = Validity.of(obj.validity) || {};
    this.rules = DiscountRuleHistory.ofList(obj.rules) || [];
  }

  public static of(obj: any = {}): DiscountUpdatedHistory {
    return new DiscountUpdatedHistory(obj);
  }
}
